import { request } from '~/services/common';

function getBaseURL() {
  return window.configs.API_HOST + '/api';
}

export async function getOrderDocuments(orderId: string): Promise<Array<App.OrderDocument>> {
  const baseURL = getBaseURL();
  const { result } = await request(`${baseURL}/orders/${orderId}/document?includeRescinded=true`);
  return result as Array<App.OrderDocument>;
}

export async function rescindOrderDocument(orderId: string, orderDocumentId: string) {
  const baseURL = getBaseURL();
  return request(`${baseURL}/orders/${orderId}/document/${orderDocumentId}/rescind`, {
    method: 'POST',
  });
}

export async function unrescindOrderDocument(orderId: string, orderDocumentId: string) {
  const baseURL = getBaseURL();
  return request(`${baseURL}/orders/${orderId}/document/${orderDocumentId}/unrescind`, {
    method: 'POST',
  });
}

export interface CreateOrderDocumentPayload {
  order_items: Array<{ item_type: string; item_id: string }>;
  document_id: string;
  document_type: string;
  s3_object_uri: string;
}

export async function createOrderDocument(orderId: string, payload: CreateOrderDocumentPayload) {
  const baseURL = getBaseURL();
  return request(`${baseURL}/orders/${orderId}/document`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function getOrderDocumentDownloadLink(orderId: string, documentId: string) {
  const baseURL = getBaseURL();
  const { result } = await request(`${baseURL}/orders/${orderId}/document/${documentId}`);
  const url = result?.downloadLink as string | undefined;
  if (!url) {
    throw new Error('Download link not available');
  }
  return { url };
}
